import React, { useState } from 'react';
import ContactForm from '../components/forms/ContactForm';
import Footer from '../components/common/Footer';
import { LuMessagesSquare } from 'react-icons/lu';
import { BiWorld } from 'react-icons/bi';
import { FcCallback } from 'react-icons/fc';
import ReviewSlider from '../components/common/ReviewSlider';
import ConfirmationModal from '../components/common/ConfirmationModal';

const ContactUs = () => {
    const [confirmationModal, setConfirmationModal] = useState(null);
    return (
        <div className='text-richblack-5 mt-14'>
            <div className='w-11/12 max-w-maxContent flex lg:flex-row flex-col lg:mt-20 mt-8 mb-20 mx-auto gap-x-10'>
                <aside className='lg:p-6 p-3 bg-richblack-800 rounded-xl lg:w-[40%] h-fit mb-9'>
                    <div className='text-richblack-300 flex flex-col gap-5'>
                        <div>
                            <header className='flex items-center gap-3 text-2xl'><LuMessagesSquare /> <span className='text-richblack-5 text-lg font-bold'>Chat with Us</span></header>
                            <p className='my-1'>Our friendly team of one person is here to help.</p>
                            <p>studynexaa@gmail.com</p>
                        </div>
                        <div>
                            <header className='flex items-center gap-3 text-2xl'><BiWorld /> <span className='text-richblack-5 text-lg font-bold'>Visit Us</span></header>
                            <p className='my-1'>Come and say hello at our office HQ.</p>
                            <p>House no.2, Street no.1, Gangore Nagar, near Sukhadiya Circle, Sri Ganganagar, Rajasthan, India - 335001</p>
                        </div>
                        <div>
                            <header className='flex items-center gap-3 text-2xl'><FcCallback /> <span className='text-richblack-5 text-lg font-bold'>Call Us</span></header>
                            <p className='my-1'>Mon - Sun From 9AM to 7AM</p>
                            <p>+91 95303-63236</p>
                        </div>
                    </div>
                </aside>
                <aside>
                    <div className='border rounded-lg  border-richblack-600 lg:p-10 p-3'>
                        <div className='mb-8'>
                            <header className='lg:text-4xl text-3xl font-bold mb-4'>Got an Idea? We've got the skills. Let's Team Up</header>
                            <p className='text-richblack-300'>Tell us more about yourself and what you've got in mind.</p>
                        </div>
                        <div>
                            <ContactForm
                                setConfirmationModal={setConfirmationModal}
                            />
                        </div>
                    </div>
                </aside>
            </div>
            <div className='w-11/12 max-w-maxContent mx-auto'>
                <h2 className='text-center md:text-4xl text-3xl md:font-semibold font-bold my-10'>Review from Learners</h2>
                <ReviewSlider />
            </div>
            <Footer />
            {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
        </div>
    )
}

export default ContactUs;